import Header from '../components/Header';
import Footer from '../components/Footer';
import QAButton from '../components/QAButton';

const SecuredLayout = ({ children }) => {
  const PageLayout = ({ children }) => {
    return <div className={'mx-auto max-w-(--breakpoint-xl) w-full px-2.5'}>{children}</div>;
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <Header />
      <div className={'w-full h-auto grow flex flex-col bg-gray-100'}>
        <PageLayout>{children}</PageLayout>
      </div>
      <Footer />
      <QAButton />
    </div>
  );
};

export default SecuredLayout;
